// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Inter", sans-serif;
  font-style: normal;
}

.abstract-form {
  display: flex;
  flex-direction: column;
}
.abstract-form .ant-select-selection-placeholder {
  font-weight: normal;
}
.abstract-form .btn-container {
  display: flex;
  justify-content: space-between;
  justify-content: flex-start;
  align-items: center;
  margin: 0px 42px 10px 0px;
}
.abstract-form .btn-container .expert-name {
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: left;
}
.abstract-form .btn-container .expert-name span {
  display: flex;
  align-items: center;
  margin-left: 8px;
  height: 25px;
  border-radius: 4px;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 16px;
}
.abstract-form .container1 {
  display: flex;
}
.abstract-form .container1 .form-container {
  width: 100%;
}
.abstract-form .form-container::-webkit-scrollbar {
  width: 5px;
}
.abstract-form .form-container::-webkit-scrollbar-track {
  width: 10px;
  background: #fff;
}
.abstract-form .form-container::-webkit-scrollbar-thumb {
  height: 433px;
  background: #cdd7e0;
}
.abstract-form .form-container::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.abstract-form .ant-select-arrow {
  color: #323232;
}

.publish-btn-container {
  display: flex;
  column-gap: 10px;
}

.publish-btn .ant-btn {
  background: #586f80;
  border-radius: 2px;
  height: 32px;
  min-width: 95px;
  width: auto;
  padding-inline: 16px;
  white-space: nowrap;
  color: white;
  font-weight: 600;
  text-align: center;
  transition: all 0.5s linear;
  border: none !important;
}
.publish-btn .ant-btn:hover, .publish-btn .ant-btn:focus {
  color: white;
  background: #586f80;
  border: none;
}

.ant-btn .ant-btn-primary {
  position: absolute;
  top: 81px;
  right: 16px;
}

/**
* if the following code is uncommented, the asterisk for required field will not be shown
.ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::before {
    content: '' !important;
    margin-right: 0 !important;
}

* if uncommented, the colon after the label in a form field will be hidden
.ant-form-item-label > label::after {
    content: '' !important;
}

.ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::after {
    content: '' !important;
}
*/
.textArea {
  flex-direction: column !important;
}

.ant-form-item textarea.ant-input {
  min-height: 109px !important;
  padding: 12px 9px;
}

.upload {
  flex-direction: column !important;
}
.upload .label-paragraph {
  margin-bottom: 12px;
  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
  width: max-content;
}

.ant-form-item-label > label {
  font-size: 16px !important;
}

.checkbox1 {
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: 300 !important;
  font-size: 16px;
  display: flex;
  align-items: flex-start;
}
.checkbox1 span {
  line-height: 14px;
}

.tags .ant-tag-checkable-checked {
  background-color: #586f80;
  color: #fff !important;
}
.tags .ant-tag {
  border-radius: 50px;
  padding: 6.4px 15px;
  border: 1px solid #586f80 !important;
  color: #323232;
  font-size: 14px;
  font-weight: normal;
  margin: 0 24px 15px 0;
  width: fit-content;
}
.tags .ant-tag:hover {
  color: #f8fafb !important;
  background-color: #586f80 !important;
}

.addField-btn {
  margin-top: -10px !important;
}
.addField-btn button {
  padding-left: 0;
  padding-top: 0;
  font-weight: 600;
  font-size: 16px;
  color: #637f92;
}
.addField-btn .ant-btn {
  border: none;
}
.addField-btn .ant-btn:active, .addField-btn .ant-btn:hover, .addField-btn .ant-btn:focus {
  color: #586f80 !important;
}
.addField-btn .ant-btn-block {
  width: 0%;
}

.ant-input {
  color: #323232 !important;
}

.ant-select-selection-item {
  font-weight: normal;
}

.ant-select-selector:hover,
.ant-select-selector:focus-within {
  border: 1px solid #586f80 !important;
  box-shadow: none !important;
}

.delete-question {
  margin-top: 9px;
  margin-left: 8px;
  height: 13px;
  cursor: pointer;
}

.tags-wrapper {
  display: grid;
  grid-template-columns: auto auto auto;
}

/** is it required to overwrite the library colors using important?
.ant-input:focus,
.ant-input-focused,
.ant-input:hover,
.ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled):hover,
.ant-input-affix-wrapper:focus {
    border-color: #586f80 !important;
    box-shadow: none !important;
}

.ant-picker:hover,
.ant-picker-focused,
.ant-picker-hover,
.ant-picker-affix-wrapper:not(.ant-input-affix-wrapper-disabled):hover,
.ant-picker-affix-wrapper:focus {
    border-color: #586f80 !important;
    box-shadow: none !important;
}

.ant-checkbox-checked .ant-checkbox-inner {
    background-color: #586f80 !important;
    border-color: #586f58 !important;
}

.ant-checkbox-wrapper:hover .ant-checkbox-inner,
.ant-checkbox:hover .ant-checkbox-inner,
.ant-checkbox-input:focus + .ant-checkbox-inner {
    border-color: #586f58 !important;
}
*/
.nested-checkbox-input {
  align-items: center;
  justify-content: space-around;
  height: 104px;
  padding: 32px !important;
  background: rgba(240, 244, 247, 0.4);
}

.ql-toolbar.ql-snow + .ql-container.ql-snow {
  border-top: 0px;
  min-height: 200px;
}

.ql-editor {
  overflow-y: scroll;
  resize: vertical;
}

.card {
  width: 705px;
  min-height: 250px;
  background: rgba(240, 244, 247, 0.4) !important;
  border: none !important;
  margin-bottom: 28px !important;
}
.card .ant-card-body .ant-row {
  align-items: flex-start;
}
.card .ant-card-head-title {
  font-size: 16px;
}
.card .card-content .ant-col .ant-col-8 .ant-form-item-label {
  width: 329px;
}
.card .ant-card-body {
  padding: 24px 0px 24px 20px;
}
.card .card-content div {
  width: 355px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.card .ant-col-8 {
  flex: none;
  max-width: 45%;
}

.option-card {
  border: none !important;
}
.option-card .ant-form-item-explain-error {
  position: absolute;
  left: -260px;
}
.option-card .ant-card-head-title {
  position: relative;
  right: 23px;
  font-size: 16px;
  font-weight: 600;
}
.option-card .option-card-checkbox {
  position: relative;
  right: 286px;
}
.option-card .ant-col-8 {
  flex: none;
  max-width: 46%;
}

.table .ant-form-item-label {
  display: none;
}
.table .ant-form-item-control {
  max-width: 100%;
}
.table .ant-form-item-control .ant-form-item-control-input-content {
  max-width: 100% !important;
}
.table .ant-form-item-control > .table-btn-container {
  margin-top: 0;
}

.checkboxGroupContainer {
  display: grid;
  grid-template-columns: 45% 55%;
  column-gap: 10px;
}

.abstract-form:not(.users-form-layout) .form-container {
  width: 100%;
}
.abstract-form:not(.users-form-layout) .collapse1 {
  margin-bottom: 18px;
}
.abstract-form:not(.users-form-layout) .collapse1 .ant-collapse {
  overflow: hidden;
  border: 1px solid #e1e8f0 !important;
  border-radius: 8px;
  background: #fff;
}
.abstract-form:not(.users-form-layout) .collapse1 .ant-collapse-content-box {
  padding: 0 !important;
}
.abstract-form:not(.users-form-layout) .collapse1 .ant-form-item {
  display: flex;
  align-items: flex-start;
  min-height: 76px;
  margin: 0 !important;
  padding: 16px 24px;
  border-bottom: 1px solid #e8eef4;
}
.abstract-form:not(.users-form-layout) .collapse1 .ant-form-item:last-child {
  border-bottom: 0;
}
.abstract-form:not(.users-form-layout) .collapse1 .ant-form-item > .ant-row {
  width: 100%;
}
.abstract-form:not(.users-form-layout) .collapse1 .ant-form-item .ant-form-item-label {
  flex: 0 0 22% !important;
  padding: 8px 20px 0 0 !important;
  text-align: left !important;
}
.abstract-form:not(.users-form-layout) .collapse1 .ant-form-item .ant-form-item-label > label {
  height: auto !important;
  color: #172033 !important;
  font-size: 15px !important;
  font-weight: 600;
  line-height: 22px;
}
.abstract-form:not(.users-form-layout) .collapse1 .ant-form-item .ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::before {
  color: #ef233c !important;
}
.abstract-form:not(.users-form-layout) .collapse1 .ant-form-item .ant-form-item-control {
  flex: 1 1 !important;
  max-width: none !important;
  min-width: 0;
}
.abstract-form:not(.users-form-layout) .collapse1 .ant-form-item .ant-col-offset-4 {
  margin-left: 0 !important;
}
.abstract-form:not(.users-form-layout) .collapse1 .ant-form-item .ant-input,
.abstract-form:not(.users-form-layout) .collapse1 .ant-form-item .ant-input-affix-wrapper,
.abstract-form:not(.users-form-layout) .collapse1 .ant-form-item .ant-input-number,
.abstract-form:not(.users-form-layout) .collapse1 .ant-form-item .ant-picker,
.abstract-form:not(.users-form-layout) .collapse1 .ant-form-item .ant-select-selector {
  width: 100% !important;
  height: 44px !important;
  border: 1px solid #ccd8e5 !important;
  border-radius: 6px !important;
  box-shadow: none !important;
  color: #172033 !important;
  font-size: 15px;
}
.abstract-form:not(.users-form-layout) .collapse1 .ant-form-item .ant-select-selector input {
  min-height: 44px !important;
}
.abstract-form:not(.users-form-layout) .collapse1 .ant-form-item .ant-input-number-input {
  min-height: 44px !important;
}
.abstract-form:not(.users-form-layout) .collapse1 .ant-form-item .ant-input,
.abstract-form:not(.users-form-layout) .collapse1 .ant-form-item .ant-input-number-input,
.abstract-form:not(.users-form-layout) .collapse1 .ant-form-item .ant-picker-input > input {
  padding: 10px 14px;
}
.abstract-form:not(.users-form-layout) .collapse1 .ant-form-item .ant-select-single .ant-select-selector {
  display: flex;
  align-items: center;
  padding: 0 14px !important;
}
.abstract-form:not(.users-form-layout) .collapse1 .ant-form-item .ant-select-multiple {
  height: auto !important;
  max-height: none !important;
  overflow: visible !important;
}
.abstract-form:not(.users-form-layout) .collapse1 .ant-form-item .ant-select-multiple .ant-select-selector {
  height: auto !important;
  min-height: 44px !important;
  max-height: none !important;
  overflow: visible !important;
  padding: 4px 10px !important;
}
.abstract-form:not(.users-form-layout) .collapse1 .ant-form-item .ant-select-multiple .ant-select-selection-overflow {
  flex-wrap: wrap !important;
  row-gap: 4px;
}
.abstract-form:not(.users-form-layout) .collapse1 .ant-form-item .ant-select-multiple .ant-select-selection-item,
.abstract-form:not(.users-form-layout) .collapse1 .ant-form-item .ant-select-multiple .ant-select-selection-placeholder {
  max-width: none !important;
}
.abstract-form:not(.users-form-layout) .collapse1 .ant-form-item .ant-select-multiple .ant-select-clear,
.abstract-form:not(.users-form-layout) .collapse1 .ant-form-item .ant-select-multiple .ant-select-selection-item-remove {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  color: #60758d;
  opacity: 1;
}
.abstract-form:not(.users-form-layout) .collapse1 .ant-form-item .ant-select-multiple .ant-select-clear {
  position: absolute;
  top: 10px;
  right: 12px;
  z-index: 2;
}
.abstract-form:not(.users-form-layout) .collapse1 .ant-form-item .ant-select-selection-placeholder,
.abstract-form:not(.users-form-layout) .collapse1 .ant-form-item .ant-input::placeholder,
.abstract-form:not(.users-form-layout) .collapse1 .ant-form-item textarea::placeholder {
  color: #7c96b5 !important;
  font-weight: 400;
}
.abstract-form:not(.users-form-layout) .collapse1 .ant-form-item .ant-input:hover,
.abstract-form:not(.users-form-layout) .collapse1 .ant-form-item .ant-input:focus,
.abstract-form:not(.users-form-layout) .collapse1 .ant-form-item .ant-input-focused,
.abstract-form:not(.users-form-layout) .collapse1 .ant-form-item .ant-input-affix-wrapper:hover,
.abstract-form:not(.users-form-layout) .collapse1 .ant-form-item .ant-input-affix-wrapper-focused,
.abstract-form:not(.users-form-layout) .collapse1 .ant-form-item .ant-input-number:hover,
.abstract-form:not(.users-form-layout) .collapse1 .ant-form-item .ant-input-number-focused,
.abstract-form:not(.users-form-layout) .collapse1 .ant-form-item .ant-picker:hover,
.abstract-form:not(.users-form-layout) .collapse1 .ant-form-item .ant-picker-focused,
.abstract-form:not(.users-form-layout) .collapse1 .ant-form-item .ant-select-focused .ant-select-selector,
.abstract-form:not(.users-form-layout) .collapse1 .ant-form-item .ant-select-selector:hover {
  border-color: #0b63ce !important;
  box-shadow: 0 0 0 2px rgba(11, 99, 206, 0.08) !important;
}
.abstract-form:not(.users-form-layout) .collapse1 .ant-form-item textarea.ant-input,
.abstract-form:not(.users-form-layout) .collapse1 .ant-form-item .textAreaInput {
  width: 100% !important;
  max-width: none !important;
  resize: vertical;
}
.abstract-form:not(.users-form-layout) .collapse1 .ant-form-item.textArea, .abstract-form:not(.users-form-layout) .collapse1 .ant-form-item.upload {
  min-height: 132px;
}
.abstract-form:not(.users-form-layout) .collapse1 .ant-form-item .upload-container,
.abstract-form:not(.users-form-layout) .collapse1 .ant-form-item .addField-input .ant-input,
.abstract-form:not(.users-form-layout) .collapse1 .ant-form-item .addField-input-wrapper .ant-row {
  width: 100% !important;
}
.abstract-form:not(.users-form-layout) .collapse1 .ant-form-item .addField-btn {
  width: 100%;
  margin: 0 !important;
}
.abstract-form:not(.users-form-layout) .collapse1 .ant-form-item .addField-btn .ant-btn,
.abstract-form:not(.users-form-layout) .collapse1 .ant-form-item .addField-btn .ant-btn-block {
  width: 100% !important;
  height: 48px;
  border: 1px dashed #b9c9da !important;
  border-radius: 6px;
  background: #fbfdff;
  color: #075dc5 !important;
  font-size: 15px;
  font-weight: 600;
}
.abstract-form:not(.users-form-layout) .collapse1 .ant-form-item .addField-btn .ant-btn:hover, .abstract-form:not(.users-form-layout) .collapse1 .ant-form-item .addField-btn .ant-btn:focus,
.abstract-form:not(.users-form-layout) .collapse1 .ant-form-item .addField-btn .ant-btn-block:hover,
.abstract-form:not(.users-form-layout) .collapse1 .ant-form-item .addField-btn .ant-btn-block:focus {
  border-color: #075dc5 !important;
  background: #f3f8ff;
}
.abstract-form:not(.users-form-layout) .collapse1 .ant-form-item .ant-radio-button-wrapper {
  height: 44px;
  margin-right: 12px;
  padding: 0 20px;
  border: 1px solid #ccd8e5 !important;
  border-radius: 6px !important;
  line-height: 42px;
}
.abstract-form:not(.users-form-layout) .collapse1 .ant-form-item .ant-radio-button-wrapper::before {
  display: none !important;
}
.abstract-form:not(.users-form-layout) .btn-container .publish-btn-container {
  gap: 12px;
}
.abstract-form:not(.users-form-layout) .btn-container .ant-btn {
  min-width: 112px;
  height: 44px;
  padding: 0 24px;
  border-radius: 6px;
  border-color: #b9c9da;
  color: #172033;
  font-size: 15px;
  font-weight: 600;
  box-shadow: none;
}
.abstract-form:not(.users-form-layout) .btn-container .ant-btn-primary {
  border-color: #075dc5 !important;
  background: #075dc5 !important;
  color: #fff !important;
}

@media (max-width: 768px) {
  .abstract-form:not(.users-form-layout) {
    padding-inline: 14px;
  }
  .abstract-form:not(.users-form-layout) .collapse1 .ant-form-item {
    display: block;
    padding: 16px;
  }
  .abstract-form:not(.users-form-layout) .collapse1 .ant-form-item .ant-form-item-label {
    max-width: 100% !important;
    padding: 0 0 8px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Entity/AbstractForm/style.scss"],"names":[],"mappings":"AAAA;EACE,SAAA;EACA,UAAA;EACA,sBAAA;EACA,gCAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;AACF;AACE;EACE,mBAAA;AACJ;AAEE;EACE,aAAA;EACA,8BAAA;EACA,2BAAA;EACA,mBAAA;EACA,yBAAA;AAAJ;AAEI;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AAAN;AAEM;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAAR;AAKE;EACE,aAAA;AAHJ;AAKI;EACE,WAAA;AAHN;AAOE;EACE,UAAA;AALJ;AAQE;EACE,WAAA;EACA,gBAAA;AANJ;AASE;EACE,aAAA;EACA,mBAAA;AAPJ;AAUE;EACE,gBAAA;AARJ;AAWE;EACE,cAAA;AATJ;;AAaA;EACE,aAAA;EACA,gBAAA;AAVF;;AAcE;EACE,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EACA,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,2BAAA;EACA,uBAAA;AAXJ;AAaI;EAEE,YAAA;EACA,mBAAA;EACA,YAAA;AAZN;;AAiBA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;AAdF;;AAsBA;;;;;;;;;;;;;;;CAAA;AAiBA;EACE,iCAAA;AApBF;;AAuBA;EACE,4BAAA;EACA,iBAAA;AApBF;;AAuBA;EACE,iCAAA;AApBF;AAsBE;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AApBJ;;AAwBA;EACE,0BAAA;AArBF;;AAwBA;EACE,gCAAA;EACA,kBAAA;EACA,2BAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;AArBF;AAuBE;EACE,iBAAA;AArBJ;;AA0BE;EACE,yBAAA;EACA,sBAAA;AAvBJ;AA0BE;EACE,mBAAA;EACA,mBAAA;EACA,oCAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;AAxBJ;AA0BI;EACE,yBAAA;EACA,oCAAA;AAxBN;;AA6BA;EACE,4BAAA;AA1BF;AA4BE;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AA1BJ;AA6BE;EACE,YAAA;AA3BJ;AA6BI;EAGE,yBAAA;AA7BN;AAiCE;EACE,SAAA;AA/BJ;;AAmCA;EACE,yBAAA;AAhCF;;AAmCA;EACE,mBAAA;AAhCF;;AAmCA;;EAEE,oCAAA;EACA,2BAAA;AAhCF;;AAmCA;EACE,eAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;AAhCF;;AAmCA;EACE,aAAA;EACA,qCAAA;AAhCF;;AAmCA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAAA;AA+BA;EACE,mBAAA;EACA,6BAAA;EACA,aAAA;EACA,wBAAA;EACA,oCAAA;AAjCF;;AAqCA;EACE,eAAA;EACA,iBAAA;AAlCF;;AAqCA;EACE,kBAAA;EACA,gBAAA;AAlCF;;AAyCA;EACE,YAAA;EACA,iBAAA;EACA,+CAAA;EACA,uBAAA;EACA,8BAAA;AAtCF;AAyCI;EACE,uBAAA;AAvCN;AA2CE;EACE,eAAA;AAzCJ;AA6CI;EACE,YAAA;AA3CN;AA+CE;EACE,2BAAA;AA7CJ;AAgDE;EACE,YAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AA9CJ;AAiDE;EACE,UAAA;EACA,cAAA;AA/CJ;;AAmDA;EACE,uBAAA;AAhDF;AAkDE;EACE,kBAAA;EACA,YAAA;AAhDJ;AAmDE;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AAjDJ;AAoDE;EACE,kBAAA;EACA,YAAA;AAlDJ;AAqDE;EACE,UAAA;EACA,cAAA;AAnDJ;;AAwDE;EACE,aAAA;AArDJ;AAwDE;EACE,eAAA;AAtDJ;AAwDI;EACE,0BAAA;AAtDN;AAyDI;EACE,aAAA;AAvDN;;AA4DA;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;AAzDF;;AA+DE;EACE,WAAA;AA5DJ;AA+DE;EACE,mBAAA;AA7DJ;AA+DI;EACE,gBAAA;EACA,oCAAA;EACA,kBAAA;EACA,gBAAA;AA7DN;AAgEI;EACE,qBAAA;AA9DN;AAiEI;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gCAAA;AA/DN;AAiEM;EACE,gBAAA;AA/DR;AAkEM;EACE,WAAA;AAhER;AAmEM;EACE,wBAAA;EAEA,gCAAA;EACA,2BAAA;AAlER;AAoEQ;EACE,uBAAA;EACA,yBAAA;EACA,0BAAA;EACA,gBAAA;EACA,iBAAA;AAlEV;AAoEU;EACE,yBAAA;AAlEZ;AAuEM;EACE,oBAAA;EACA,0BAAA;EACA,YAAA;AArER;AAwEM;EACE,yBAAA;AAtER;AAyEM;;;;;EAKE,sBAAA;EACA,uBAAA;EACA,oCAAA;EACA,6BAAA;EACA,2BAAA;EACA,yBAAA;EACA,eAAA;AAvER;AA0EM;EACE,2BAAA;AAxER;AA2EM;EACE,2BAAA;AAzER;AA2EM;;;EAGE,kBAAA;AAzER;AA6EM;EACE,aAAA;EACA,mBAAA;EACA,0BAAA;AA3ER;AA+EM;EACE,uBAAA;EACA,2BAAA;EACA,4BAAA;AA7ER;AA+EQ;EACE,uBAAA;EACA,2BAAA;EACA,2BAAA;EACA,4BAAA;EACA,4BAAA;AA7EV;AAgFQ;EACE,0BAAA;EACA,YAAA;AA9EV;AAiFQ;;EAEE,0BAAA;AA/EV;AAoFQ;;EAEE,+BAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,UAAA;AAlFV;AAqFQ;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;AAnFV;AAuFM;;;EAGE,yBAAA;EACA,gBAAA;AArFR;AAwFM;;;;;;;;;;;EAWE,gCAAA;EACA,wDAAA;AAtFR;AAyFM;;EAEE,sBAAA;EACA,0BAAA;EAGA,gBAAA;AAzFR;AA4FM;EAEE,iBAAA;AA3FR;AA8FM;;;EAGE,sBAAA;AA5FR;AA+FM;EACE,WAAA;EACA,oBAAA;AA7FR;AA+FQ;;EAEE,sBAAA;EACA,YAAA;EACA,qCAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;AA7FV;AA+FU;;;EAEE,gCAAA;EACA,mBAAA;AA5FZ;AAiGM;EACE,YAAA;EACA,kBAAA;EACA,eAAA;EACA,oCAAA;EACA,6BAAA;EACA,iBAAA;AA/FR;AAiGQ;EACE,wBAAA;AA/FV;AAyGI;EACE,SAAA;AAvGN;AA0GI;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,qBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAxGN;AA2GI;EACE,gCAAA;EACA,8BAAA;EACA,sBAAA;AAzGN;;AA8GA;EACE;IACE,oBAAA;EA3GF;EA6GE;IACE,cAAA;IACA,aAAA;EA3GJ;EA6GI;IACE,0BAAA;IACA,2BAAA;EA3GN;AACF","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  font-family: 'Inter', sans-serif;\n  font-style: normal;\n}\n\n.abstract-form {\n  display: flex;\n  flex-direction: column;\n\n  .ant-select-selection-placeholder {\n    font-weight: normal;\n  }\n\n  .btn-container {\n    display: flex;\n    justify-content: space-between;\n    justify-content: flex-start;\n    align-items: center;\n    margin: 0px 42px 10px 0px;\n\n    .expert-name {\n      display: flex;\n      align-items: center;\n      font-size: 20px;\n      font-weight: 600;\n      line-height: 24px;\n      letter-spacing: 0px;\n      text-align: left;\n\n      span {\n        display: flex;\n        align-items: center;\n        margin-left: 8px;\n        height: 25px;\n        border-radius: 4px;\n        font-family: 'Inter', sans-serif;\n        font-size: 16px;\n        font-weight: 600;\n        line-height: 16px;\n      }\n    }\n  }\n\n  .container1 {\n    display: flex;\n\n    .form-container {\n      width: 100%;\n    }\n  }\n\n  .form-container::-webkit-scrollbar {\n    width: 5px;\n  }\n\n  .form-container::-webkit-scrollbar-track {\n    width: 10px;\n    background: #fff;\n  }\n\n  .form-container::-webkit-scrollbar-thumb {\n    height: 433px;\n    background: #cdd7e0;\n  }\n\n  .form-container::-webkit-scrollbar-thumb:hover {\n    background: #555;\n  }\n\n  .ant-select-arrow {\n    color: #323232;\n  }\n}\n\n.publish-btn-container {\n  display: flex;\n  column-gap: 10px;\n}\n\n.publish-btn {\n  .ant-btn {\n    background: #586f80;\n    border-radius: 2px;\n    height: 32px;\n    min-width: 95px;\n    width: auto;\n    padding-inline: 16px;\n    white-space: nowrap;\n    color: white;\n    font-weight: 600;\n    text-align: center;\n    transition: all 0.5s linear;\n    border: none !important;\n\n    &:hover,\n    &:focus {\n      color: white;\n      background: #586f80;\n      border: none;\n    }\n  }\n}\n\n.ant-btn .ant-btn-primary {\n  position: absolute;\n  top: 81px;\n  right: 16px;\n}\n\n.ant-form-horizontal .ant-form-item-label {\n  // this aligns the labels of the form field to the left which are by default set to right\n  // text-align: left;\n}\n\n/**\n* if the following code is uncommented, the asterisk for required field will not be shown\n.ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::before {\n    content: '' !important;\n    margin-right: 0 !important;\n}\n\n* if uncommented, the colon after the label in a form field will be hidden\n.ant-form-item-label > label::after {\n    content: '' !important;\n}\n\n.ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::after {\n    content: '' !important;\n}\n*/\n\n.textArea {\n  flex-direction: column !important;\n}\n\n.ant-form-item textarea.ant-input {\n  min-height: 109px !important;\n  padding: 12px 9px;\n}\n\n.upload {\n  flex-direction: column !important;\n\n  .label-paragraph {\n    margin-bottom: 12px;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 17px;\n    width: max-content;\n  }\n}\n\n.ant-form-item-label > label {\n  font-size: 16px !important;\n}\n\n.checkbox1 {\n  font-family: 'Inter', sans-serif;\n  font-style: normal;\n  font-weight: 300 !important;\n  font-size: 16px;\n  display: flex;\n  align-items: flex-start;\n\n  span {\n    line-height: 14px;\n  }\n}\n\n.tags {\n  .ant-tag-checkable-checked {\n    background-color: #586f80;\n    color: #fff !important;\n  }\n\n  .ant-tag {\n    border-radius: 50px;\n    padding: 6.4px 15px;\n    border: 1px solid #586f80 !important;\n    color: #323232;\n    font-size: 14px;\n    font-weight: normal;\n    margin: 0 24px 15px 0;\n    width: fit-content;\n\n    &:hover {\n      color: #f8fafb !important;\n      background-color: #586f80 !important;\n    }\n  }\n}\n\n.addField-btn {\n  margin-top: -10px !important;\n\n  button {\n    padding-left: 0;\n    padding-top: 0;\n    font-weight: 600;\n    font-size: 16px;\n    color: #637f92;\n  }\n\n  .ant-btn {\n    border: none;\n\n    &:active,\n    &:hover,\n    &:focus {\n      color: #586f80 !important;\n    }\n  }\n\n  .ant-btn-block {\n    width: 0%;\n  }\n}\n\n.ant-input {\n  color: #323232 !important;\n}\n\n.ant-select-selection-item {\n  font-weight: normal;\n}\n\n.ant-select-selector:hover,\n.ant-select-selector:focus-within {\n  border: 1px solid #586f80 !important;\n  box-shadow: none !important;\n}\n\n.delete-question {\n  margin-top: 9px;\n  margin-left: 8px;\n  height: 13px;\n  cursor: pointer;\n}\n\n.tags-wrapper {\n  display: grid;\n  grid-template-columns: auto auto auto;\n}\n\n/** is it required to overwrite the library colors using important?\n.ant-input:focus,\n.ant-input-focused,\n.ant-input:hover,\n.ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled):hover,\n.ant-input-affix-wrapper:focus {\n    border-color: #586f80 !important;\n    box-shadow: none !important;\n}\n\n.ant-picker:hover,\n.ant-picker-focused,\n.ant-picker-hover,\n.ant-picker-affix-wrapper:not(.ant-input-affix-wrapper-disabled):hover,\n.ant-picker-affix-wrapper:focus {\n    border-color: #586f80 !important;\n    box-shadow: none !important;\n}\n\n.ant-checkbox-checked .ant-checkbox-inner {\n    background-color: #586f80 !important;\n    border-color: #586f58 !important;\n}\n\n.ant-checkbox-wrapper:hover .ant-checkbox-inner,\n.ant-checkbox:hover .ant-checkbox-inner,\n.ant-checkbox-input:focus + .ant-checkbox-inner {\n    border-color: #586f58 !important;\n}\n*/\n\n.nested-checkbox-input {\n  align-items: center;\n  justify-content: space-around;\n  height: 104px;\n  padding: 32px !important;\n  background: rgba(240, 244, 247, 0.4);\n}\n\n// this is textEditor style\n.ql-toolbar.ql-snow + .ql-container.ql-snow {\n  border-top: 0px;\n  min-height: 200px;\n}\n\n.ql-editor {\n  overflow-y: scroll;\n  resize: vertical;\n}\n\n// .ant-card-bordered{\n//   margin: 0 !important;\n// }\n\n.card {\n  width: 705px;\n  min-height: 250px;\n  background: rgba(240, 244, 247, 0.4) !important;\n  border: none !important;\n  margin-bottom: 28px !important;\n\n  .ant-card-body {\n    .ant-row {\n      align-items: flex-start;\n    }\n  }\n\n  .ant-card-head-title {\n    font-size: 16px;\n  }\n\n  .card-content {\n    .ant-col .ant-col-8 .ant-form-item-label {\n      width: 329px;\n    }\n  }\n\n  .ant-card-body {\n    padding: 24px 0px 24px 20px;\n  }\n\n  .card-content div {\n    width: 355px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  .ant-col-8 {\n    flex: none;\n    max-width: 45%;\n  }\n}\n\n.option-card {\n  border: none !important;\n\n  .ant-form-item-explain-error {\n    position: absolute;\n    left: -260px;\n  }\n\n  .ant-card-head-title {\n    position: relative;\n    right: 23px;\n    font-size: 16px;\n    font-weight: 600;\n  }\n\n  .option-card-checkbox {\n    position: relative;\n    right: 286px;\n  }\n\n  .ant-col-8 {\n    flex: none;\n    max-width: 46%;\n  }\n}\n\n.table {\n  .ant-form-item-label {\n    display: none;\n  }\n\n  .ant-form-item-control {\n    max-width: 100%;\n\n    .ant-form-item-control-input-content {\n      max-width: 100% !important;\n    }\n\n    & > .table-btn-container {\n      margin-top: 0;\n    }\n  }\n}\n\n.checkboxGroupContainer {\n  display: grid;\n  grid-template-columns: 45% 55%;\n  column-gap: 10px;\n}\n\n// Shared visual layer for the dynamic fields inside the existing accordion.\n// This is intentionally presentational only: no accordion or form logic changes.\n.abstract-form:not(.users-form-layout) {\n  .form-container {\n    width: 100%;\n  }\n\n  .collapse1 {\n    margin-bottom: 18px;\n\n    .ant-collapse {\n      overflow: hidden;\n      border: 1px solid #e1e8f0 !important;\n      border-radius: 8px;\n      background: #fff;\n    }\n\n    .ant-collapse-content-box {\n      padding: 0 !important;\n    }\n\n    .ant-form-item {\n      display: flex;\n      align-items: flex-start;\n      min-height: 76px;\n      margin: 0 !important;\n      padding: 16px 24px;\n      border-bottom: 1px solid #e8eef4;\n\n      &:last-child {\n        border-bottom: 0;\n      }\n\n      > .ant-row {\n        width: 100%;\n      }\n\n      .ant-form-item-label {\n        flex: 0 0 22% !important;\n       \n        padding: 8px 20px 0 0 !important;\n        text-align: left !important;\n\n        > label {\n          height: auto !important;\n          color: #172033 !important;\n          font-size: 15px !important;\n          font-weight: 600;\n          line-height: 22px;\n\n          &.ant-form-item-required:not(.ant-form-item-required-mark-optional)::before {\n            color: #ef233c !important;\n          }\n        }\n      }\n\n      .ant-form-item-control {\n        flex: 1 1 0 !important;\n        max-width: none !important;\n        min-width: 0;\n      }\n\n      .ant-col-offset-4 {\n        margin-left: 0 !important;\n      }\n\n      .ant-input,\n      .ant-input-affix-wrapper,\n      .ant-input-number,\n      .ant-picker,\n      .ant-select-selector {\n        width: 100% !important;\n        height: 44px !important;\n        border: 1px solid #ccd8e5 !important;\n        border-radius: 6px !important;\n        box-shadow: none !important;\n        color: #172033 !important;\n        font-size: 15px;\n      }\n\n      .ant-select-selector input{\n        min-height: 44px !important;\n      }\n\n      .ant-input-number-input {\n        min-height: 44px !important;\n      }\n      .ant-input,\n      .ant-input-number-input,\n      .ant-picker-input > input {\n        padding: 10px 14px;\n        \n      }\n\n      .ant-select-single .ant-select-selector {\n        display: flex;\n        align-items: center;\n        padding: 0 14px !important;\n      }\n\n      // Multiple selections wrap and expand the field instead of scrolling.\n      .ant-select-multiple {\n        height: auto !important;\n        max-height: none !important;\n        overflow: visible !important;\n\n        .ant-select-selector {\n          height: auto !important;\n          min-height: 44px !important;\n          max-height: none !important;\n          overflow: visible !important;\n          padding: 4px 10px !important;\n        }\n\n        .ant-select-selection-overflow {\n          flex-wrap: wrap !important;\n          row-gap: 4px;\n        }\n\n        .ant-select-selection-item,\n        .ant-select-selection-placeholder {\n          max-width: none !important;\n        }\n\n        // Keep Ant Design's existing clear and per-selection remove controls\n        // visible after the field expands for multiple selected values.\n        .ant-select-clear,\n        .ant-select-selection-item-remove {\n          display: inline-flex !important;\n          align-items: center;\n          justify-content: center;\n          color: #60758d;\n          opacity: 1;\n        }\n\n        .ant-select-clear {\n          position: absolute;\n          top: 10px;\n          right: 12px;\n          z-index: 2;\n        }\n      }\n\n      .ant-select-selection-placeholder,\n      .ant-input::placeholder,\n      textarea::placeholder {\n        color: #7c96b5 !important;\n        font-weight: 400;\n      }\n\n      .ant-input:hover,\n      .ant-input:focus,\n      .ant-input-focused,\n      .ant-input-affix-wrapper:hover,\n      .ant-input-affix-wrapper-focused,\n      .ant-input-number:hover,\n      .ant-input-number-focused,\n      .ant-picker:hover,\n      .ant-picker-focused,\n      .ant-select-focused .ant-select-selector,\n      .ant-select-selector:hover {\n        border-color: #0b63ce !important;\n        box-shadow: 0 0 0 2px rgba(11, 99, 206, 0.08) !important;\n      }\n\n      textarea.ant-input,\n      .textAreaInput {\n        width: 100% !important;\n        max-width: none !important;\n        \n        \n        resize: vertical;\n      }\n\n      &.textArea,\n      &.upload {\n        min-height: 132px;\n      }\n\n      .upload-container,\n      .addField-input .ant-input,\n      .addField-input-wrapper .ant-row {\n        width: 100% !important;\n      }\n\n      .addField-btn {\n        width: 100%;\n        margin: 0 !important;\n\n        .ant-btn,\n        .ant-btn-block {\n          width: 100% !important;\n          height: 48px;\n          border: 1px dashed #b9c9da !important;\n          border-radius: 6px;\n          background: #fbfdff;\n          color: #075dc5 !important;\n          font-size: 15px;\n          font-weight: 600;\n\n          &:hover,\n          &:focus {\n            border-color: #075dc5 !important;\n            background: #f3f8ff;\n          }\n        }\n      }\n\n      .ant-radio-button-wrapper {\n        height: 44px;\n        margin-right: 12px;\n        padding: 0 20px;\n        border: 1px solid #ccd8e5 !important;\n        border-radius: 6px !important;\n        line-height: 42px;\n\n        &::before {\n          display: none !important;\n        }\n      }\n    }\n  }\n\n  .btn-container {\n    // margin: 8px 0 24px !important;\n    // padding: 10px 0 0;\n\n    .publish-btn-container {\n      gap: 12px;\n    }\n\n    .ant-btn {\n      min-width: 112px;\n      height: 44px;\n      padding: 0 24px;\n      border-radius: 6px;\n      border-color: #b9c9da;\n      color: #172033;\n      font-size: 15px;\n      font-weight: 600;\n      box-shadow: none;\n    }\n\n    .ant-btn-primary {\n      border-color: #075dc5 !important;\n      background: #075dc5 !important;\n      color: #fff !important;\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .abstract-form:not(.users-form-layout) {\n    padding-inline: 14px;\n\n    .collapse1 .ant-form-item {\n      display: block;\n      padding: 16px;\n\n      .ant-form-item-label {\n        max-width: 100% !important;\n        padding: 0 0 8px !important;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
